import { resolveImagePath } from '@/utils/imageResolver';

interface ServiceItem {
  title: string;
  imagePath: string;
  alt: string;
}

const services: ServiceItem[] = [
  {
    title: "Comprehensive FBO Services",
    imagePath: "/images/fbo-services.jpg",
    alt: "FBO Services - Aircraft ground support and fueling"
  },
  {
    title: "Maintenance & Avionics", 
    imagePath: "/images/maintenance-services.jpg",
    alt: "Aircraft maintenance and avionics services"
  },
  {
    title: "Prop Shop",
    imagePath: "/images/prop-shop-services.jpg", 
    alt: "Propeller overhaul and repair services"
  },
  {
    title: "Aircraft Charter",
    imagePath: "/images/charter-services.jpg",
    alt: "Aircraft charter services"
  }
];

export function ServicesGallery() {
  return (
    <section className="py-0">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
        {services.map((service, index) => (
          <div key={index} className="relative group overflow-hidden">
            <div className="aspect-[4/3] relative">
              <img
                src={resolveImagePath(service.imagePath)}
                alt={service.alt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                loading="lazy"
              />
              {/* Dark overlay for better text contrast */}
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>
              
              {/* Service title overlay */}
              <div className="absolute inset-0 flex items-center justify-center p-6">
                <h3 className="text-white text-xl font-bold text-center leading-tight">
                  {service.title}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}